import KeyValueMap from './_key-value-map.js'

export default {
  name: 'Intent',
  values: {
    type: undefined,
    data: {
      $mixin: [
        {
          configSet: KeyValueMap,
        },
      ],
    },
  },
  meta: {
    extendable: false,
  },
}
